import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { getFacilitiesExportExcelDownloadFinal } from 'services/fund'

export default function useGetFinalDownload() {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: string | undefined) => {
            return getFacilitiesExportExcelDownloadFinal(payload)
        },
        onSuccess: (data) => {},
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
